var TECHNOLOGY = {
	onLoad: function(){
		console.log("Tech JS loaded")
	},
	addListeners: function(){
		console.log("Tech Listeners added!")
		var topSectionHeight = $('#topSlide').height() + $('header').height();
		TECHNOLOGY.displayIconMenu(topSectionHeight);
		if ( $(".carousel").length > 0 ) {
			$('.carousel').carousel();
		}
		if ( $('.tech-page__icon').length > 0 ) {
			$('.tech-page__icon').click(function(event) {
				if ( !$(this).hasClass('active')){
					if ( $(window).width() < 991 ){
						var mainTech = $('.home-tech__text-and-image-wrapper.mobile#main');
					} else {
						var mainTech = $('.home-tech__text-and-image-wrapper.desktop#main');
					}
					var selectedTech = $(this).attr('data-tech-number');
					var prevTech = $(".home-tech__text-and-image-wrapper.active");
					var selectedTechHandle = $('.home__tech--image-wrapper').attr('data-product-handle');
					TECHNOLOGY.replacePreviousTech(mainTech, prevTech, selectedTech)
					TECHNOLOGY.activateIcons(selectedTech);
				}
			});
			$(window).scroll(function() {
				var topSectionHeight = $('#topSlide').height() + $('header').height();
				TECHNOLOGY.displayIconMenu(topSectionHeight);
			})
			$('.tech-page__icon').click(function(event) {
				var selectedTechIndex = parseInt($(this).attr('data-tech-number'));
				TECHNOLOGY.techPageActivateIcon(selectedTechIndex);
			});
		}
	},
	displayIconMenu: function(topSectionHeight) {
		if ( $(window).width() < 991 ){
			var menu = $('.icon-menu.mobile');
			var mobileMenu = 0;
		} else {
			var menu = $('.icon-menu.desktop');
			var mobileMenu = $('.icon-menu.mobile');
		}
		if ( $(window).scrollTop() > topSectionHeight ) {
			var bottomOffSet = ( $(document).height() ) - ( $('footer').height() + $('.newsletter__wrapper').height() + $('.section.last').height() )
			console.log(bottomOffSet);
			if ( $(window).scrollTop() > bottomOffSet ) {
				$(menu).hide("slide", {direction: "left"}, 300)
				if ( $(window).width() < 991 ){
					menu.removeClass('shown');
				}
			}	else {
				$(menu).show("slide", {direction: "left"}, 300)
				if ( $(window).width() < 991 ){
					menu.addClass('shown');
					if ( mobileMenu.length > 0 ){
						mobileMenu.hide();
					}
				}
			}
		} else {
			$(menu).hide("slide", {direction: "left"}, 300).removeClass('shown');
			if ( $(window).width() < 991 ){
				menu.removeClass('shown');
			}
		}
	},
	replacePreviousTech: function(mainTech, prevTech, selectedTech) {
		// tech wrapper
		var selectedTechWrapper = $('.home-tech__text-and-image-wrapper').filter("[data-tech='" + selectedTech + "']");
		// tech header
		var newHeader = selectedTechWrapper.find('h2').text();
		mainTech.find('h2').fadeOut(function() {
		  $(this).text(newHeader);
		}).fadeIn();
		// tech text
		if (  $(window).width() < 991  ) {
			var newText = selectedTechWrapper.find('.home-tech--text.mobile').text();
			console.log(newText);
			mainTech.find('.home-tech--text').fadeOut(function() {
				$(this).text('');
			  $(this).text(newText);
			}).fadeIn();
		} else {
			var newText = selectedTechWrapper.find('.home-tech--text.desktop').text();
			mainTech.find('.home-tech--text').fadeOut(function() {
			  $(this).text(newText);
			}).fadeIn();
		}
		// tech link
		var newLinkText = selectedTechWrapper.find('.home-tech--text-wrapper').find('a').text();
		var newLink = selectedTechWrapper.find('.home-tech--text-wrapper').find('a').attr('href');
		mainTech.find('.home-tech--text-wrapper').find('a').attr('href', newLink);
		mainTech.find('.home-tech--text-wrapper').find('a').text(newLinkText);

		// tech image
		if ( $(window).width() < 768 ){
			var newImageWrapper = selectedTechWrapper.find('.tech-page__image-wrapper.mobile').children().clone();
			// tech product name header
			var productMobileText = mainTech.find('.mobile--tech__text').first();
			var newProductMobileText = selectedTechWrapper.find('.mobile--tech__text').clone();
			productMobileText.fadeOut(function() {
			  $(this).html(newProductMobileText);
			}).fadeIn();
			mainTech.find('.tech-page__image-wrapper.mobile').fadeOut(function() {
			  selectedTechWrapper.find('.tech-page__image-wrapper.mobile').append(newImageWrapper);
			  $(this).html(newImageWrapper)
			}).fadeIn();
		} else {
			var newImageWrapper = selectedTechWrapper.find('.tech-page__image-wrapper.desktop').children().clone();
			mainTech.find('.tech-page__image-wrapper.desktop').fadeOut(function() {
			  $(this).html(newImageWrapper)
			}).fadeIn();
		}
	},
	activateIcons: function(selectedTech){
		// icons
		var prevTechIcon = $('.tech-page__icon.active');
		var selectedTechIcon = $('.tech-page__icon').filter("[data-tech-number='" + selectedTech + "']");
		prevTechIcon.removeClass('active').addClass('grow');
		selectedTechIcon.removeClass('grow').addClass('active');
		prevTechIcon.find('path, polygon').attr('style', "stroke:#9B9B9B; fill:#9B9B9B").css({
			'-o-transform': 'scale(1)',
			'-moz-transform': 'scale(1)',
			'-webkit-transform': 'scale(1)',
			'transform': 'scale(1)',
		});
		selectedTechIcon.find('path, polygon').attr('style', "stroke:#000; fill:#000")/*.css({
			// '-o-transform': 'scale(1.2)',
			// '-moz-transform': 'scale(1.2)',
			// '-webkit-transform': 'scale(1.2)',
			// 'transform': 'scale(1.2)',
		})*/;
	},
	techPageActivateIcon: function(selectedTechIndex){
		var selectedTechIcon = $('.tech-page__icon').filter("[data-tech-number='" + selectedTechIndex + "']");
		$('.tech-page__icon').removeClass('active').find('path, polygon').attr('style', "stroke:#9B9B9B; fill:#9B9B9B")
		selectedTechIcon.removeClass('grow').addClass('active');
		selectedTechIcon.find('path, polygon').attr('style', "stroke:#000; fill:#000")/*.css({
			'-o-transform': 'scale(1.2)',
			'-moz-transform': 'scale(1.2)',
			'-webkit-transform': 'scale(1.2)',
			'transform': 'scale(1.2)',
		})*/;
	}
}

$(function(){
	TECHNOLOGY.addListeners();
	TECHNOLOGY.onLoad();
});

$(function(){
	var st = 0,
  fixThreshold = 20,
  numberOfItems = $('#fullpage .fp-section').length;
  function reenableScroll(){
    $.fn.fullpage.setAutoScrolling(false);
    $(document.body).css('padding-right',0);
    st = $(window).scrollTop();
    $(window).on('scroll.fix', scrollHandler);
  }
  function scrollHandler(){
    if($(window).scrollTop() < st - fixThreshold){
      $.fn.fullpage.setAutoScrolling(true);
      $(window).off('scroll.fix');
    };
  }
  function activateIcon(index){
		$('.tech__tech--image-wrapper').each(function(){
			$(this).removeClass('svg-shown');
		});
		var actualSlide = index - 1;
		$('#slide'+actualSlide).find('.tech__tech--image-wrapper').addClass('svg-shown');
	}
	if ( $("#fullpage").length > 0 ) {
		$('#fullpage').fullpage({
			anchors: ['top',
							'DryFUZE',
							'ClimaFUZE',
							'UltraFUZE',
							// 'GreenFUZE',
							'FeatherFUZE',
							'FreSHIELD',
							'GloFUZE',
							'LXFUZE'],
			menu: '#menu',
			css3: true,
			continuousVertical: false,
			hybrid: true,
			fitToSection: false,
			// afterRender: function(){
			// 	console.log('HIDE THE LOADER NOW');
   //    	$('.loader__wrapper').hide();
   //    },
			afterLoad: function(anchorLink, index){
				numberOfItems = $('#fullpage .fp-section').length;
				activateIcon(index);
				TECHNOLOGY.techPageActivateIcon(index - 1);

				console.log("Slides " + numberOfItems);
				console.log("Index " + index);
				if ( index === numberOfItems ) {
					reenableScroll();
				}
			},
			onLeave: function(index, nextIndex, direction){
				// numberOfItems = $('#fullpage .fp-section').length;
				// if ( index === (numberOfItems - 1) && direction === 'down'){
				// 	reenableScroll();
				// } else {
				// 	if ( index === numberOfItems && direction === 'up' ) {
				// 		$.fn.fullpage.silentMoveTo(index - 1);
				// 	}
				// 	$.fn.fullpage.setAutoScrolling(true);
		  //     $(window).off('scroll.fix');
				// }
			}
		});
	}
});

$(window).load(function(){
	$('.loader__wrapper').hide();
});





